import { React } from 'react';
import { Image, useColorModeValue } from '@chakra-ui/react';
import lightLogo from './../images/buildsoft-logo-square.svg';
import darkLogo from './../images/buildsoft-logo-square-dark.svg';

export default function Logo(props) {
  const logo = useColorModeValue(lightLogo, darkLogo);
  return <Image src={logo} alt="BuildSoft logo" {...props} />;
}
